import React, { Fragment } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import NoData from "./NoData";

const FlightTableData = ({ data }) => {
  const styles = StyleSheet.create({
    Flightcontainer: {
      flexDirection: "row",
      alignItems: "center",
      fontStyle: "bold",
      paddingBottom: "5px",
      paddingTop: "10px",
      paddingLeft: "15px",
      border: "1px solid #E4E4E4",
      borderRadius: "5px",
      width: "100%",
      marginTop: "5px",
    },
    departure: {
      width: "20%",
      fontSize: "11px",
      color: "#333333",
    },
    form: {
      width: "15%",
      fontSize: "11px",
      color: "#333333",
    },
    to: {
      width: "15%",
      fontSize: "11px",
      color: "#333333",
    },
    description: {
      width: "20%",
      fontSize: "11px",
      color: "#333333",
    },
    meal: {
      width: "15%",
      fontSize: "11px",
      color: "#333333",
    },
    seat: {
      width: "15%",
      fontSize: "11px",
      color: "#333333",
    },
  });
  return (
    <Fragment>
      {data && data?.flight_reservations?.trips?.length > 0 ? (
        data?.flight_reservations?.trips?.map((items, index) => (
          <View style={styles.Flightcontainer}>
            <Text style={styles.departure}>
              {items?.departure_date ? items?.departure_date : "-"}
            </Text>
            <Text style={styles.form}>
              {items?.from_city ? items?.from_city : "-"}
            </Text>
            <Text style={styles.to}>
              {items?.to_city ? items?.to_city : "-"}
            </Text>
            <Text style={styles.description}>
              {data?.flight_reservations?.description
                ? data?.flight_reservations?.description
                : "-"}
            </Text>
            <Text style={styles.meal}>
              {data?.flight_reservations?.meal_preference
                ? data?.flight_reservations?.meal_preference
                : "-"}
            </Text>
            <Text style={styles.seat}>
              {data?.flight_reservations?.seat_preference
                ? data?.flight_reservations?.seat_preference
                : "-"}
            </Text>
          </View>
        ))
      ) : (
        <NoData title="Flight Data" />
      )}
    </Fragment>
  );
};

export default FlightTableData;
